module.exports = __webpack_public_path__ + "static/media/18.cb841a46.jpg";